import React from "react";
import Layout from "../../components/Layout/Layout";
import DeactivateForm from "./DeactivateForm";

const ReqDeactivate = () => {
  return (
    <>
      <Layout>
        <div className="bred_crumb blog_detail_bredcrumb">
          <div className="container">
            <div className="bred_text">
              <h1>Account Deactivation</h1>
            </div>
          </div>
        </div>

        <section className="blog_detail_section">
          <div className="container">
            <div className="blog_inner_pannel plan-cancel">
              <div className="container">
                <h4>Deactivation Policy</h4>
                <p className="mb-5">
                  You may request to deactivate your account at any time.
                  <br />
                  Once deactivated, your account access will be disabled and
                  related services may no longer be available.
                </p>

                <h4 className="mb-4">Request Account Deactivation</h4>
                <DeactivateForm />
                {/* You may rename RefundForm to DeactivateForm later */}
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default ReqDeactivate;
